import { request } from '../../helpers/api/request';
import {
    GetAdditionalSettingsContract,
} from '../../types/Endpoints/documents/DocumentsContracts';

export const getAdditionalSettings = async () => {
    const { data } = await request<GetAdditionalSettingsContract>({
        url: 'admin/settings',
    });

    return data;
};
